export default "__VITE_ASSET__33a1e7d7__"